





































































































































import { Vue } from 'vue-property-decorator';
import { FeedbackModel, FeedbackTypeConstants } from '@/types';
import { FeedbackService } from '@/services';
import { FormFieldValidation, ObjectHelper, FeedbackHelper } from '@/mixins';
import { UserService } from '@/services/UserService';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { EmailConstants } from '@/types/constants/EmailConstants';

export default Vue.extend({
  name: 'Feedback',
  mixins: [FormFieldValidation, ObjectHelper, FeedbackHelper],
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Feedback'
    }
  },
  data() {
    return {
      successMessage: 'Thanks for your feedback.',
      isSending: false,
      isLoading: false,
      feedbackModel: {},
      user: {},
      subjectList: [],
      selectedSubject: null,
      showSuccessMessage: false
    };
  },
  methods: {
    async onSubmit(this: any) {
      const formIsvalid = await this.validateFeedbackFormAsync();
      if (formIsvalid) {
        this.isSending = true;
        try {
          const result = await FeedbackService.sendFeedbackEmailAsync(this.feedbackModel);
          if (result) {
            this.showSuccessMessage = true;
          }
        } catch (error) {
          this.handleError(error);
        } finally {
          this.isSending = false;
        }
      }
    },
    async validateFeedbackFormAsync() {
      try {
        return this.$validator.validateAll('feedbackForm');
      } catch (error) {
        this.$log('validator error ' + error);
        return false;
      }
    },
    resetFeedbackForm(this: any) {
      this.feedbackModel = {
        includeUserInformation: true
      } as FeedbackModel;
      this.setSelectedSubject();
      this.showSuccessMessage = false;
      this.$validator.reset();
      this.$validator.errors.remove('apiError');
    },
    onReset(this: any) {
      this.resetFeedbackForm();
    },
    onClose(this: any) {
      this.resetFeedbackForm();
      this.closeModal();
    },
    handleError(error: any) {
      this.$validator.errors.remove('apiError');
      this.$validator.errors.add({
        field: 'apiError',
        msg: error.notification
      });
    },
    async getUserInformation(this: any) {
      try {
        this.user = await UserService.getCurrentUserAsync();
      } catch {
        this.user = {};
      }
    },
    async getSubjectList(this: any) {
      try {
        const getFeedbackSubjectsResponse = await FeedbackService.getFeedbackSubjectsAsync();
        this.initializeFeedbackSubjects(getFeedbackSubjectsResponse);
      } catch {
        this.subjectList = [];
      }
    },
    initialize(this: any) {
      this.isLoading = true;
      this.resetFeedbackForm();
      this.getUserInformation();
      this.getSubjectList();
      this.isLoading = false;
    },
    initializeFeedbackSubjects(this: any, feedbackSubjects: any) {
      if (this.title === FeedbackTypeConstants.GetHelp.title) {
        this.subjectList = feedbackSubjects[FeedbackTypeConstants.GetHelp.key];
      } else if (this.title === FeedbackTypeConstants.ReportIssue.title) {
        this.subjectList = feedbackSubjects[FeedbackTypeConstants.ReportIssue.key];
      } else {
        this.subjectList = feedbackSubjects[FeedbackTypeConstants.Feedback.key];
      }
      this.setSelectedSubject();
    },
    setSelectedSubject(this: any) {
      if (this.subjectList?.length > 0) {
        this.selectedSubject = this.title === FeedbackTypeConstants.Feedback.title ? null : this.subjectList[0];
        this.feedbackModel.subject = this.selectedSubject;
      }
    },
    updateFeedbackModel(this: any, propertyKey: string, newValue: string) {
      this.feedbackModel = { ...this.feedbackModel, [propertyKey]: newValue };
    }
  },
  watch: {
    selectedSubject(this: any) {
      this.feedbackModel.subject = this.selectedSubject === 'custom' ? null : this.selectedSubject;
      if (this.selectedSubject === 'custom') {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.resetField('subject', 'feedbackForm');
          });
        });
      }
    }
  },
  computed: {
    isRequired(this: any) {
      return this.selectedSubject === null || this.selectedSubject !== 'custom';
    },
    isDisabled(this: any) {
      return this.title !== FeedbackTypeConstants.Feedback.title;
    }
  },
  created(this: any) {
    this.EMAIL_CONSTANTS = EmailConstants;
  },
  mounted(this: any) {
    this.initialize();
  },
  components: { LoadingSpinner }
});
